import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div>
        <small>
          <p>Copyright &copy; 2021 | All rights reserved</p>
          <p>
            This app was developed with{" "}
            <i className="ui heart icon red large"></i>by{" "}
            <a
              href="https://linkedin.com/in/obioraigboanusi"
              target="_blank"
              rel="noreferrer"
            >
              Obiora Igboanusi
            </a>
          </p>
        </small>
      </div>
    </footer>
  );
}

export default Footer;
